// extracted by mini-css-extract-plugin
module.exports = {"root":"az_pbb","disabled":"az_qbb"};